<div class="p-20">
  <h3>{{"HEADER.CHOOSE_LANGUAGE" | translate}}</h3>
  <form [formGroup]="form" (ngSubmit)="onSubmit()">
    <mat-form-field appearance="outline" class="w-100 m-t-20">
      <mat-select formControlName="language">
        @for (language of languagesOptions; track language) {
          <mat-option [value]="language">
            <img [src]="'/assets/images/flag/icon-flag-'+language+'.svg'" width="20">
            {{supportedLanguages[language]}}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
    <div class="w-100 text-center">
      <button mat-raised-button color="primary" type="submit" class="m-t-30"
      [disabled]="form.invalid">{{"HEADER.CONFIRM" | translate}}</button>
    </div>
  </form>
</div>